import CheckModal from './CheckModal';

export default CheckModal;
